import React, { useState } from "react";
const TF={" 15m":"15분","1h":"1시간","4h":"4시간","1d":"1일"};
export default function TechPanel({ data }) {
  const [tf,setTf] = useState("1h");
  if (!data) return <p style={{color:"#6b7280"}}>데이터 없음</p>;
  const d = data[tf]||{};
  const rsiColor = d.rsi>70?"#ef4444":d.rsi<30?"#3b82f6":"#22c55e";
  return (
    <div style={{display:"flex",flexDirection:"column",gap:14}}>
      <div style={{display:"flex",gap:6}}>
        {Object.entries({"15m":"15분","1h":"1시간","4h":"4시간","1d":"1일"}).map(([k,l])=>{
          const rd=data[k]||{}; const rc=rd.rsi>70?"#ef4444":rd.rsi<30?"#3b82f6":"#6b7280";
          return (
            <button key={k} onClick={()=>setTf(k)} style={{flex:1,padding:"6px 4px",borderRadius:8,
              cursor:"pointer",textAlign:"center",background:tf===k?"#181c24":"#111318",
              border:tf===k?"1.5px solid #3b82f6":"1px solid #1e2433"}}>
              <p style={{fontSize:11,color:"#6b7280",marginBottom:2}}>{l}</p>
              {rd.rsi!=null&&<p style={{fontSize:13,fontWeight:700,color:rc}}>{rd.rsi}</p>}
            </button>
          );
        })}
      </div>
      {d.rsi!=null&&(
        <div>
          <div style={{display:"flex",justifyContent:"space-between",marginBottom:6}}>
            <p style={{fontSize:12,color:"#6b7280"}}>RSI (14)</p>
            <span style={{padding:"2px 8px",borderRadius:6,fontSize:11,fontWeight:700,
              background:d.rsi_state==="과매수"?"rgba(239,68,68,.15)":d.rsi_state==="과매도"?"rgba(59,130,246,.15)":"rgba(34,197,94,.15)",
              color:d.rsi_state==="과매수"?"#ef4444":d.rsi_state==="과매도"?"#3b82f6":"#22c55e"}}>{d.rsi_state}</span>
          </div>
          <div style={{display:"flex",justifyContent:"space-between",fontSize:12,color:"#6b7280",marginBottom:4}}>
            <span>과매도 ←</span><span style={{color:rsiColor,fontWeight:700,fontSize:18}}>{d.rsi}</span><span>→ 과매수</span>
          </div>
          <div style={{height:8,background:"#1e2433",borderRadius:4,overflow:"hidden"}}>
            <div style={{width:`${Math.min(100,d.rsi||50)}%`,height:"100%",
              background:"linear-gradient(90deg,#3b82f6 0%,#22c55e 40%,#f97316 70%,#ef4444 100%)",borderRadius:4}}/>
          </div>
        </div>
      )}
      {d.macd!=null&&(
        <div>
          <p style={{fontSize:12,color:"#6b7280",marginBottom:6}}>MACD</p>
          <div style={{display:"flex",gap:12,fontSize:13,flexWrap:"wrap"}}>
            <div><span style={{color:"#6b7280",fontSize:11}}>MACD</span><p style={{fontWeight:700}}>{d.macd?.toFixed(4)}</p></div>
            <div style={{alignSelf:"flex-end"}}>
              <span style={{padding:"2px 8px",borderRadius:6,fontSize:11,fontWeight:700,
                background:d.macd_cross==="골든"?"rgba(34,197,94,.15)":"rgba(239,68,68,.15)",
                color:d.macd_cross==="골든"?"#22c55e":"#ef4444"}}>{d.macd_cross} 크로스</span>
            </div>
          </div>
        </div>
      )}
      {Object.keys(d).length===0&&<p style={{color:"#4b5563",fontSize:12}}>이 타임프레임 데이터 없음</p>}
    </div>
  );
}
